/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseDataResponse_RecruitingDirectionDto_ } from '../models/BaseDataResponse_RecruitingDirectionDto_';
import type { BaseListDataResponse_RecruitingDirectionDto_ } from '../models/BaseListDataResponse_RecruitingDirectionDto_';
import type { CreateRecruitingDirectionRequest } from '../models/CreateRecruitingDirectionRequest';
import type { UpdateRecruitingDirectionRequest } from '../models/UpdateRecruitingDirectionRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HiringDirectionsService {
    /**
     * List Recruiting Directions
     * Получение списка всех направлений рекрутинга
     * @returns BaseListDataResponse_RecruitingDirectionDto_ Successful Response
     * @throws ApiError
     */
    public static listRecruitingDirectionsApiHiringDirectionsGet(): CancelablePromise<BaseListDataResponse_RecruitingDirectionDto_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hiring/directions',
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Create Direction
     * Создание нового направления рекрутинга
     * @param requestBody
     * @returns BaseDataResponse_RecruitingDirectionDto_ Successful Response
     * @throws ApiError
     */
    public static createDirectionApiHiringDirectionsPost(
        requestBody: CreateRecruitingDirectionRequest,
    ): CancelablePromise<BaseDataResponse_RecruitingDirectionDto_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/hiring/directions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get Direction
     * Получение направления по ID
     * @param directionId
     * @returns BaseDataResponse_RecruitingDirectionDto_ Successful Response
     * @throws ApiError
     */
    public static getDirectionApiHiringDirectionsDirectionIdGet(
        directionId: string,
    ): CancelablePromise<BaseDataResponse_RecruitingDirectionDto_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hiring/directions/{direction_id}',
            path: {
                'direction_id': directionId,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Code: recruiting_direction_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Update Direction
     * Обновление направления рекрутинга
     * @param directionId
     * @param requestBody
     * @returns BaseDataResponse_RecruitingDirectionDto_ Successful Response
     * @throws ApiError
     */
    public static updateDirectionApiHiringDirectionsDirectionIdPut(
        directionId: string,
        requestBody: UpdateRecruitingDirectionRequest,
    ): CancelablePromise<BaseDataResponse_RecruitingDirectionDto_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/hiring/directions/{direction_id}',
            path: {
                'direction_id': directionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                404: `Code: recruiting_direction_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Activate Direction
     * Активация направления рекрутинга
     * @param directionId
     * @returns BaseDataResponse_RecruitingDirectionDto_ Successful Response
     * @throws ApiError
     */
    public static activateDirectionApiHiringDirectionsDirectionIdActivatePost(
        directionId: string,
    ): CancelablePromise<BaseDataResponse_RecruitingDirectionDto_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/hiring/directions/{direction_id}/activate',
            path: {
                'direction_id': directionId,
            },
            errors: {
                400: `Code: recruiting_direction_already_active`,
                401: `Code: authentication_error`,
                404: `Code: recruiting_direction_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Deactivate Direction
     * Деактивация направления рекрутинга
     * @param directionId
     * @returns BaseDataResponse_RecruitingDirectionDto_ Successful Response
     * @throws ApiError
     */
    public static deactivateDirectionApiHiringDirectionsDirectionIdDeactivatePost(
        directionId: string,
    ): CancelablePromise<BaseDataResponse_RecruitingDirectionDto_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/hiring/directions/{direction_id}/deactivate',
            path: {
                'direction_id': directionId,
            },
            errors: {
                400: `Code: recruiting_direction_already_inactive`,
                401: `Code: authentication_error`,
                404: `Code: recruiting_direction_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
}
